import gender from './gender.json';

import mouth from './beard.json';

import hair_default from './hair.json';
import hair_hats from './hair_hats.json';
import hair_specials from './hair_specials.json';

import addon_default from './addon.json';
import addon_flags from './addon_flags.json';
import addon_masks from './addon_masks.json';
import addon_stuffs from './addon_stuffs.json';

import wear_default from './wear.json';
import wear_brands from './wear_brands.json';
import wear_casuals from './wear_casuals.json';
import wear_formals from './wear_formals.json';
import wear_specials from './wear_specials.json';
import wear_sports from './wear_sports.json';

// Type for asset data structure
export type AssetData = [string, Record<string, number | [number, number, number]>];
export type GenderAssets = AssetData[][][];

// Export all assets
export {
  gender,
  mouth,
  hair_default,
  hair_hats,
  hair_specials,
  addon_default,
  addon_flags,
  addon_masks,
  addon_stuffs,
  wear_default,
  wear_casuals,
  wear_formals,
  wear_brands,
  wear_specials,
  wear_sports
};

// Create a record for dynamic access
const assets: Record<string, unknown> = {
  gender,
  mouth,
  hair_default,
  hair_hats,
  hair_specials,
  addon_default,
  addon_flags,
  addon_masks,
  addon_stuffs,
  wear_default,
  wear_casuals,
  wear_formals,
  wear_brands,
  wear_specials,
  wear_sports
};

export default assets;
